import IconCloseShareholder from "../../assets/svg/close-shareholder.svg";
import IconConfirmDeleteAccount from "../../assets/svg/confirm-delete-account.svg";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setConfirm } from "../../store/actions/appAction";
import IconDelete from "../../assets/svg/delete-warning-item.svg";
import iconLoading from "../../assets/svg/icon-loading.svg";

export default function Confirm(props) {
    const dispatch = useDispatch();
    const { sendingRequest, confirm } = props;
    const message = confirm.message
    const [confirmed, setConfirmed] = useState(false);

    return confirm ? (
        !confirmed ? (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="confrim-delete-modal-step-one">
                    <div className="box-confirm-delete-step-one flex flex-col justify-between gap-5">
                       
                        <div className="body-icon-delete-modal">
                            <div className="background-icon-delete-modal">
                                <img src={IconDelete} alt="IconEdit" />
                            </div>
                        </div>
                       
                        <div className="confrim-delete-box-account">

                            {message ? <p>{message}
                            </p> :
                                <p>{"آیا از انجام عملیات اطمینان دارید؟"}</p>
                            }
                        </div>
                        <div className="btn-cancel-confirm-delete">
                            <button
                                type="button"
                                className="btn-cancel-account"
                                onClick={() => {
                                    setConfirmed(false);
                                    dispatch(setConfirm(false));
                                    if(confirm.ignoreAction)
                                    confirm.ignoreAction()
                                    
                                }}
                            >
                                انصراف
                            </button>
                            <button
                                type="button"
                                className="btn-cancel-confirm"
                                onClick={() => {
                                    confirm.action(true);
                                    dispatch(setConfirm(false));
                                }}
                            >
                                {sendingRequest ? <img src={iconLoading} alt="loading" /> : <span>تایید</span>}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="confrim-delete-modal-step-two">
                    <div className="box-confirm-delete-step-two">
                        <img
                            onClick={() => {
                                setConfirmed(false);
                                dispatch(setConfirm(false));
                            }}
                            src={IconCloseShareholder}
                            alt="IconCloseShareholder"
                            className="img-icon-close"
                        />
                        <div className="body-icon-delete-modal">
                            <div className="background-icon-delete-modal">
                                <img src={IconConfirmDeleteAccount} alt="IconConfirmDeleteAccount" />
                            </div>
                        </div>
                        <div className="wrap-text-delete-account">
                            <div className="text-delete-account">درخواست حذف {confirm.title} با موفقیت انجام گردید</div>
                        </div>
                        <div className="btn-cancel-confirm-delete">
                            <button
                                type="button"
                                className="btn-cancel-account"
                                onClick={() => {
                                    setConfirmed(false);
                                    dispatch(setConfirm(false));
                                }}
                            >
                                بستن
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    ) : null;
}
